
const imginaryUrl = (src: string) => {
  return `https://substackcdn.com/image/fetch/${encodeURIComponent(src)}`;
};

export const getPlaceholderUrl = (identity: string) => {
  return `url(${imginaryUrl(`https://substack.com/api/v1/live_stream/placeholder/${identity}.jpg`)})`;
};
